<template>
    <span class="tooltip-wrapper">
        <slot />
        <aside v-if="text"
               :class="`tooltip tooltip--${position}${withArrow ? ` tooltip--${position}--with-arrow`: ''}`"
               :style="dynamicStyles">
            <hh-msg-display class="tooltip__message"
                            :message="text"
                            :type="type" />
        </aside>
    </span>
</template>

<script>

export default {

    props: {
        text: {
            type: String,
            default: null,
        },
        type: {
            type: String,
            default: 'default',
        },
        position: {
            type: String,
            default: 'top',
        },
        withArrow: {
            type: Boolean,
            default: true,
        },
        rightLeftPositionAdjust: {
            type: [ String, Number ],
            default: '',
        },
        topBottomPositionAdjust: {
            type: [ String, Number ],
            default: '',
        },
    },

    computed: {
        dynamicStyles() {
            const stylesArr = []

            if (this.position.includes('top')) stylesArr.push(`bottom: ${ this.topBottomPositionAdjust }`)
            if (this.position.includes('bottom')) stylesArr.push(`top: ${ this.topBottomPositionAdjust }`)
            if (this.position.includes('left')) stylesArr.push(`right: ${ this.rightLeftPositionAdjust }`)
            if (this.position.includes('right')) stylesArr.push(`left: ${ this.rightLeftPositionAdjust }`)

            return stylesArr.join('; ')
        },
    },

    beforeMount() {
        const validPositions = [ 'top', 'bottom', 'left', 'right', 'top-left', 'top-right', 'bottom-left', 'bottom-right' ]
        if (!validPositions.includes(this.position))
            throw new TypeError(`The prop 'position' is invalid. Please provide one of ${ validPositions.join(', ') }`)
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\global\_hh-tooltip.scss

.tooltip {
    visibility: hidden;
    opacity: 0;
    text-align: center;
    z-index: 500;
    position: absolute;

    .message-display {
        margin-bottom: 0;
        white-space: normal;
    }
}

.no-touch {
    .tooltip-wrapper {
        position: relative;

        &:hover, &:focus {

            .tooltip {
                visibility: visible;
                transition: visibility 0.1s ease-in 0.5s;
            }
        }
    }
}

</style>
